<template>
    <div class="text-center" :style="{ color: footer.fontColor }">
        <a
            v-if="!footer.hideAbout"
            target="_blank"
            @click.prevent="goToLinkOrView(aboutUrl, 'about')"
            class="footer-link mr-5"
            :href="aboutUrl"
        >
            {{ $t("r_legal.about_us") }}
        </a>
        <a
            v-if="!footer.hidePolicy"
            target="_blank"
            @click.prevent="goToLinkOrView(privacyUrl, 'privacy')"
            class="footer-link mr-5"
            :href="privacyUrl"
        >
            {{ $t("r_legal.privacy_policy") }}
        </a>
        <a
            v-if="!footer.hideTerms"
            target="_blank"
            @click.prevent="goToLinkOrView(termsUrl, 'terms')"
            class="footer-link"
            :href="termsUrl"
        >
            {{ $t("r_legal.terms") }}
        </a>
    </div>
</template>

<script>
import { updateIframeView } from "@/shared/utils";
import { mapState } from "vuex";

export default {
    name: "cTerms",
    props: {
        footer: Object,
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        legal() {
            return this.footer?.legals?.[0] || {};
        },
        termsUrl() {
            return "/terms/" + this.legal.uuid;
        },
        privacyUrl() {
            return "/policies/" + this.legal.uuid;
        },
        aboutUrl() {
            return "/about/" + this.legal.uuid;
        },
    },
    methods: {
        goToLinkOrView(url, view) {
            if (this.preview) {
                updateIframeView("footer", this.footer.uuid, view);
                return;
            }
            window.open(url, "_blank");
        },
    },
};
</script>
